import { ChildProps } from "ts/types";

export default function CardBody({ children }: ChildProps) {
  return (
    <div className="border-t border-gray-200 px-4 py-5 sm:px-6">{children}</div>
  );
}
